import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuardService} from 'compob2b-auth';
import {DamFilesListComponent} from './list/dam-files-list.component';
import {CreateUpdateFilesComponent} from './create-update/create-update-files.component';


const routes: Routes = [

  {
    path: '', // path is: cabinet/crm/files
    component: DamFilesListComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'item/create', // path is: cabinet/crm/files
    component: CreateUpdateFilesComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: 'item/edit/:id',
    component: CreateUpdateFilesComponent,
    canActivate: [AuthGuardService]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FilesRoutingModule { }
